import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch } from 'redux/store'
import styled from 'styled-components'
import { calcLogics } from 'redux/calcBot'
import { ITradeOptionProps } from 'redux/calcBot/types'
import { getHumanTime, round, timeToHumanShort } from 'utils/utils'
import { ReactComponent as LowBalanceIcon } from 'assets/icons/lowBalance.svg'
import { useSelector } from 'react-redux'
import StyledPin from '../UI/Pin'
import { ShowFullButton } from '../../pages/Actions/ActionItem'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../routes/routes'
import { colorsEnum, theme } from '../../utils/GlobalStyles'
const pinnedKey = 'pinnedTradeOptions'

export const TradeOption: React.FC<ITradeOptionProps> = ({
  tradeOption,
  isActive,

  isInAction,
  isPinned = false,
  scrollOnChoose,
}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const selectedTradeOption = useSelector(calcLogics.selectors.selectSelectedTradeOption)
  const { firstExPing, secondExPing, marketStep, limitStep } = tradeOption

  const [pinned, setPinned] = useState(isPinned)
  const [pingIsVisible, setPingIsVisible] = useState(false)
  function bgColor(): string {
    const { marketBuy, marketSell, marketStep, limitBuy, limitSell, limitStep } = tradeOption

    return marketBuy && marketSell && marketStep && (+marketBuy > +marketStep || +marketSell > +marketStep)
      ? 'green'
      : limitBuy && limitSell && limitStep && (+limitBuy > +limitStep || +limitSell > +limitStep)
      ? 'yellow'
      : 'default'
  }

  function pinTradeOptionId(e: React.MouseEvent<HTMLInputElement>) {
    e.stopPropagation()
    const pinnedKeys = localStorage.getItem(pinnedKey)

    if (pinnedKeys) {
      const initialText = `${tradeOption.market} of ${tradeOption.firstEx}/${tradeOption.secondEx}`

      try {
        const pinnedKeysArray = JSON.parse(pinnedKeys)
        if (!pinnedKeysArray.find((e: string) => e === tradeOption._id)) {
          pinnedKeysArray.push(tradeOption._id)
          localStorage.setItem(pinnedKey, JSON.stringify(pinnedKeysArray))
          setPinned(true)
        } else {
          const filteredKeysArray = pinnedKeysArray.filter((k: string) => k !== tradeOption._id)
          localStorage.setItem(pinnedKey, JSON.stringify(filteredKeysArray))
          setPinned(false)
        }
      } catch (err) {
        const msg = `error while trying to pin TO ${initialText}`
        console.log(msg)
      }
    } else {
      localStorage.setItem(pinnedKey, JSON.stringify([tradeOption._id]))
    }
  }

  const exchangesPing = !!firstExPing && !!secondExPing && firstExPing > secondExPing ? firstExPing : secondExPing
  const lifeTimeGreen = getHumanTime(Date.now() - (tradeOption.marketSituationTime ?? 0))
  const tradeOptionRef = useRef<HTMLDivElement>(null)
  const makeScrollOnChoose = () => {
    if (
      scrollOnChoose &&
      selectedTradeOption.scrollToTradeOption &&
      selectedTradeOption.firstEx === tradeOption.firstEx &&
      selectedTradeOption.secondEx === tradeOption.secondEx &&
      selectedTradeOption.market === tradeOption.market &&
      (selectedTradeOption.secondMarket ? selectedTradeOption.secondMarket === tradeOption?.secondMarket : true)
    ) {
      tradeOptionRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
    }
  }
  useEffect(() => {
    makeScrollOnChoose()
  }, [selectedTradeOption])
  return (
    <TOWrapper
      ref={scrollOnChoose ? tradeOptionRef : undefined}
      isInAction={isInAction}
      bg={bgColor()}
      isActive={isActive}
      isFreezed={tradeOption.isFreezed}
    >
      {
        <>
          <Exchanges>
            {/*<DeleteButtonWrapper>*/}
            {/*  {isInAction ? (*/}
            {/*    <div></div>*/}
            {/*  ) : tradeOption.isDeleted ? (*/}
            {/*    <RestoreWrapper onClick={() => restoreTradeOption(tradeOption._id)}>*/}
            {/*      <RestoreIcon />*/}
            {/*    </RestoreWrapper>*/}
            {/*  ) : (*/}
            {/*    <DeleteButton*/}
            {/*      onClick={e => {*/}
            {/*        e.stopPropagation()*/}
            {/*        deleteTradeOption({*/}
            {/*          _id: tradeOption._id,*/}
            {/*          firstEx: tradeOption.firstEx,*/}
            {/*          secondEx: tradeOption.secondEx,*/}
            {/*          market: tradeOption.market,*/}
            {/*          secondMarket: tradeOption.secondMarket ?? '',*/}
            {/*        })*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      ×*/}
            {/*    </DeleteButton>*/}
            {/*  )}*/}
            {/*</DeleteButtonWrapper>*/}
            <StyledPin onClick={pinTradeOptionId} isPinned={Boolean(pinned)} />
            <Exchange>
              {tradeOption.firstEx} / {tradeOption.secondEx}
            </Exchange>
            <Buttons>
              <ExPing ping={exchangesPing} onMouseOver={() => setPingIsVisible(true)} onMouseLeave={() => setPingIsVisible(false)}>
                ◉
                {pingIsVisible && (
                  <PingOverlay>
                    <PingValue ping={firstExPing}>{firstExPing}</PingValue> | <PingValue ping={secondExPing}>{secondExPing}</PingValue>
                  </PingOverlay>
                )}
              </ExPing>
            </Buttons>
          </Exchanges>
          <TOHead>
            <StepLetter market>M</StepLetter>
            <TOName>
              {tradeOption.market}{' '}
              {!tradeOption.secondMarket || tradeOption.secondMarket === tradeOption.market ? '' : `.../${tradeOption.secondMarket.split('/')[1]}`}
            </TOName>
            <StepLetter limit>L</StepLetter>
          </TOHead>
          <TOBody>
            <TOBodyRow>
              <StepPlusValue>
                <StepBlock market style={{ paddingRight: '0' }}>
                  {marketStep}
                </StepBlock>
                <TOValue trOptValue={Math.max(tradeOption.marketBuy || 0, tradeOption.marketSell || 0)} market style={{ paddingRight: '5px' }}>
                  {round(Math.max(tradeOption.marketBuy || 0, tradeOption.marketSell || 0), 2)}
                </TOValue>
              </StepPlusValue>
              <StepPlusValue style={{ paddingLeft: '0' }}>
                <TOValue trOptValue={Math.max(tradeOption.limitBuy || 0, tradeOption.limitSell || 0)} limit style={{ paddingLeft: '5px' }}>
                  {round(Math.max(tradeOption.limitBuy || 0, tradeOption.limitSell || 0), 2)}
                </TOValue>
                <StepBlock limit>{limitStep}</StepBlock>
              </StepPlusValue>
              {/*<TOValue trOptValue={tradeOption.marketBuy || 0}>{round(tradeOption.marketBuy || 0, 2)}</TOValue>*/}
              {/*<ValuesNames>B|S</ValuesNames>*/}
              {/*<TOValue trOptValue={tradeOption.marketSell || 0}>{round(tradeOption.marketSell || 0, 2)}</TOValue>*/}
            </TOBodyRow>
            {/*<MarketVolumes>*/}
            {/*<MarketVolumesName title={'Replace time'}>*/}
            {/*  <ReplaceTimeIcon />:*/}
            {/*</MarketVolumesName>*/}
            {/*<MarketVolumesBlock>*/}
            {/*  {tradeOption.lastLimitDecisionTime ? `${timeToHumanShort(tradeOption.lastLimitDecisionTime)}` : 'N/A'}*/}
            {/*</MarketVolumesBlock>*/}

            {/*<MarketVolumesName title={'Update time'}>*/}
            {/*  <UpdateTimeIcon />:*/}
            {/*</MarketVolumesName>*/}
            {/*<LastUpdateTimeBlock delay={Date.now() - (tradeOption.lastUpdateTime || 0)}>*/}
            {/*  {tradeOption.lastUpdateTime ? timeToHumanShort(Date.now() - tradeOption.lastUpdateTime) : '--'}*/}
            {/*</LastUpdateTimeBlock>*/}
            {/*<MarketVolumesName title={`Status: ${getStatusName(tradeOption.status || tradeOption.status === 0 ? tradeOption.status : -1)}`}>*/}
            {/*  <StatusIcon />:*/}
            {/*</MarketVolumesName>*/}
            {/*<MarketVolumesBlock title={`Status: ${getStatusName(tradeOption.status || tradeOption.status === 0 ? tradeOption.status : -1)}`}>*/}
            {/*  {tradeOption.status}*/}
            {/*</MarketVolumesBlock>*/}
            {/*</MarketVolumes>*/}

            {/*<TOBodyRow>*/}
            {/*  */}
            {/*  /!*<TOValue trOptValue={tradeOption.limitBuy || 0}>{round(tradeOption.limitBuy || 0, 2)}</TOValue>*!/*/}
            {/*  /!*<ValuesNames>B|S</ValuesNames>*!/*/}
            {/*  /!*<TOValue trOptValue={tradeOption.limitSell || 0}>{round(tradeOption.limitSell || 0, 2)}</TOValue>*!/*/}
            {/*</TOBodyRow>*/}
            <Warnings>
              <FastEnableButton
                isActive={tradeOption.isFastLimitEnable}
                isLogicEnabled={tradeOption.isAutoLimitEnabled}
                isTradeEnabled={tradeOption.tradeEnabled}
              >
                LE
              </FastEnableButton>
              <FastEnableButton
                isActive={tradeOption.isFastBMEnable}
                isLogicEnabled={tradeOption.isBMEnabled}
                isTradeEnabled={tradeOption.tradeEnabled}
              >
                BM
              </FastEnableButton>
              <LowBalance>{tradeOption.lowBalance && <LowBalanceIcon />}</LowBalance>
              <TimeBlock>
                <MarketVolumesName title={'Update time'}>st:</MarketVolumesName>
                <LifeTimeTimer>{lifeTimeGreen}</LifeTimeTimer>
              </TimeBlock>
              <TimeBlock>
                <MarketVolumesName title={'Update time'}>ut:</MarketVolumesName>
                <LastUpdateTimeBlock delay={Date.now() - (tradeOption.lastUpdateTime || 0)}>
                  {tradeOption.lastUpdateTime ? timeToHumanShort(Date.now() - tradeOption.lastUpdateTime) : '--'}
                </LastUpdateTimeBlock>
              </TimeBlock>
              <StatButton
                onClick={() => {
                  dispatch(
                    calcLogics.actions.editActionsFilterByExchange({
                      firstEx: tradeOption.firstEx,
                      secondEx: tradeOption.secondEx,
                      market: tradeOption.market,
                      secondMarket: tradeOption.secondMarket && tradeOption.market !== tradeOption.secondMarket ? tradeOption.secondMarket : 'All',
                    })
                  )
                  navigate(routes.Actions)
                }}
              >
                Stat
              </StatButton>
            </Warnings>
          </TOBody>
        </>
      }
    </TOWrapper>
  )
}

const FastEnableButton = styled.span<{ isActive?: boolean; isLogicEnabled?: boolean; isTradeEnabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 6px;
  font-weight: 600;
  line-height: 1;
  width: 12px;
  height: 12px;
  white-space: nowrap;
  user-select: none;
  border-radius: 50%;
  padding: 3px;
  background-color: ${({ isActive, isLogicEnabled, theme, isTradeEnabled }) => {
    if (isTradeEnabled) {
      if (isActive) {
        if (isLogicEnabled) {
          return 'rgb(1,183,155)'
        }
        return theme.red
      } else {
        if (isLogicEnabled) {
          return theme.yellow
        }
        return '#4f4d4d'
      }
    } else {
      return '#4f4d4d'
    }
  }};
  color: ${({ isActive, isLogicEnabled, isTradeEnabled }) => {
    if (isTradeEnabled) {
      if (isActive) {
        if (isLogicEnabled) {
          return '#000'
        }
        return '#fff'
      } else {
        return '#fff'
      }
    } else {
      return '#fff'
    }
  }};
`

const LifeTimeTimer = styled.div`
  width: 25px;
  overflow: hidden;
  white-space: nowrap;
`

const PingValue = styled.span<{ ping?: number }>`
  z-index: 100;
  color: ${({ ping, theme }) => {
    if (ping !== undefined) {
      return ping >= 0 && ping < 5 ? theme.green : ping > 5 && ping < 10 ? theme.yellow : theme.red
    }
  }};
`
const PingOverlay = styled.div`
  position: absolute;
  top: 20px;
  right: -20px;
  color: #fff;
  height: fit-content;
  box-shadow: rgb(0 0 0 / 8%) 0 0 8px, rgb(0 0 0 / 8%) 0 4px 8px;
  background-color: rgb(67, 68, 72);
  border-radius: 4px;
  padding: 5px;
  display: flex;
  z-index: 500;

  & > span:first-child {
    margin-right: 5px;
  }

  & > span:last-child {
    margin-left: 5px;
  }
`

const Warnings = styled.div`
  height: 15px;
  justify-content: space-between;
  align-items: center;
  min-width: 10px;
  display: flex;
  font-size: 10px;
  margin-top: 8px;
`

export const CustomInput = styled.input<{ zeroLimit?: boolean }>`
  background: rgba(255, 255, 255, 0.11);
  border: 0.3px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 1px 1px 1px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  padding: 1px 5px;
  width: 30px;
  color: ${({ theme }) => theme.alabasterWhite};
  font-weight: 500;
  font-size: 12px;
  margin-right: 10px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${({ zeroLimit }) => {
    if (zeroLimit) {
      return `
        animation: 3s ease-out 2 zeroLimitBlink;
        animation-iteration-count: 3;
        animation-delay: 2s;
        @keyframes zeroLimitBlink{
          0% {
            border: 0.3px solid ${theme.red};
          }
          100% {
            border: 0.3px solid rgba(255, 255, 255, 0.1);
          }
        }
      `
    }
  }}
`

const DeleteButton = styled.button`
  border: none;
  border-radius: 50%;
  background: ${({ theme }) => theme.red};
  width: 11px;
  height: 11px;
  margin: 2px 0 0 0;
  padding: 1px 0 0;
  color: #000;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
`

const MuteButton = styled.button<{
  isMuted?: boolean
}>`
  border: none;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  //padding-top: 1px;
  color: #fff;
  justify-content: center;
  display: flex;
  opacity: ${({ isMuted }) => (isMuted ? 1 : 0)};
`

export const TOWrapper = styled.div<{
  color?: string
  isActive?: boolean
  bg?: string
  isInAction?: boolean
  isFreezed?: boolean
}>`
  padding: 6px;
  height: 95px;
  color: ${({ isActive, theme }) => (isActive ? theme.alabasterWhite : theme.white50)};
  border: 1px solid
    ${({ color, bg, isInAction, isFreezed, theme }) => {
      return isFreezed
        ? 'rgba(51, 214, 255, 0.2)'
        : color === 'yellow'
        ? '#333227'
        : // : color === 'red'
        // ? '#472525'
        bg === 'green'
        ? `${theme.getColorWithOpacity(colorsEnum.green, 70)} !important`
        : bg === 'yellow'
        ? `${theme.getColorWithOpacity(colorsEnum.yellow, 70)} !important`
        : isInAction
        ? theme.dark
        : `rgba(255, 255, 255, 0.15) !important`
      // return theme.dark
    }};

  background: ${({ color, bg, isInAction, isFreezed, theme, isActive }) => {
    return isFreezed
      ? 'rgba(51, 214, 255, 0.2)'
      : bg === 'green' && isActive
      ? `${theme.getColorWithOpacity(colorsEnum.green, 25)} !important`
      : bg === 'yellow' && isActive
      ? `${theme.getColorWithOpacity(colorsEnum.yellow, 25)} !important`
      : isActive
      ? `${theme.white11} !important`
      : theme.dark
  }};

  border-radius: 2px;
  position: relative;
  min-width: 175px;
  max-width: 175px;

  &:hover {
    ${DeleteButton} {
      display: flex;
    }

    ${MuteButton} {
      opacity: 1;
    }
    background: ${({ color, bg, isInAction, isFreezed, theme }) => {
      return isFreezed
        ? 'rgba(51, 214, 255, 0.2)'
        : bg === 'green'
        ? `${theme.getColorWithOpacity(colorsEnum.green, 25)} !important`
        : bg === 'yellow'
        ? `${theme.getColorWithOpacity(colorsEnum.yellow, 25)} !important`
        : isInAction
        ? theme.dark
        : `${theme.white11} !important`
    }};
    color: ${({ theme }) => theme.alabasterWhite};
  }
`
const ExPing = styled.span<{
  ping?: number
  children?: React.ReactNode | React.ReactNode[]
}>`
  position: relative;
  cursor: pointer;
  color: ${({ ping, theme }) => {
    if (ping !== undefined) {
      return ping >= 0 && ping < 5 ? theme.green : ping > 5 && ping < 10 ? theme.yellow : theme.red
    }
  }};
`

const TOHead = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
`

const TOName = styled.div`
  width: 61.6%;
  font-weight: 500;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  align-self: flex-start;
  svg {
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }
`

const Buttons = styled.div`
  display: flex;
  align-items: center;
  padding-left: 2px;
`

const TOBody = styled.div`
  //padding-top: 5px;
`

const TOBodyRow = styled.div`
  display: flex;
  margin-bottom: 2px;
  align-items: center;
  justify-content: space-between;
`

const TOValue = styled.div<{
  trOptValue: number
  market?: boolean
  limit?: boolean
}>`
  width: 60%;
  height: 16.5px;
  text-align: center;
  font-weight: normal;
  font-size: 14px;
  color: ${({ trOptValue, theme }) => (trOptValue > 0 ? theme.green : theme.red)};
  white-space: nowrap;
  overflow: hidden;
  &:hover {
    overflow: visible;
    z-index: 1;
  }
`

const Exchanges = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 4px;
`
const Exchange = styled.div`
  font-weight: 600;
  font-size: 12px;
  // color: ${({ theme }) => theme.white66};
`

const MarketVolumesName = styled.div`
  width: 13px;
`

const LowBalance = styled.div`
  display: flex;
  align-items: center;
  animation: warn 1s infinite;
  @keyframes warn {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

const StepBlock = styled.div<{ market?: boolean; limit?: boolean }>`
  width: 40%;
  height: 16.5px;
  //margin-right: 10px;
  display: flex;
  border-radius: 3px;
  justify-content: center;
  overflow: hidden;
  align-items: center;
  padding: 2px 5px;
  font-size: 11px;

  border-bottom-left-radius: ${({ limit }) => (limit ? 0 : '3px')};
  border-bottom-right-radius: ${({ market }) => (market ? 0 : '3px')};
  &:hover {
    overflow: visible;
  }
`
export const StatButton = styled.button`
  font-size: 10px;
  line-height: 1;
  padding: 1px 1px;
  border-radius: 2px;
  border: 1px solid #ffffff66;
  color: #ffffff66;
  &:hover {
    border-color: #fff;
    color: #fff;
  }
  &:active {
    color: #ffffff88;
    background: #ffffff22;
  }
`

const LastUpdateTimeBlock = styled.div<{ delay: number }>`
  width: 25px;
  overflow: hidden;
  color: ${({ delay, theme }) => (delay > 5000 ? theme.yellow : delay > 10000 ? theme.red : theme.green)};
  &:hover {
    overflow: visible;
  }
`

const StepPlusValue = styled.div`
  display: flex;
  width: 48%;
`

const StepLetter = styled.div<{ market?: boolean; limit?: boolean }>`
  width: 19.2%;
  display: flex;
  font-size: 9px;
  justify-content: center;
  align-self: flex-end;
  color: ${({ market, limit, theme }) => (market ? theme.green : limit ? theme.yellow : 'none')};
`

const TimeBlock = styled.div`
  display: flex;
`
